import { flow } from 'fp-ts/function';
import { DurationObjectUnits } from 'luxon';
import { TimeUnit } from '@mews/enums';
import { createHandler } from '@mews/std';
import { DateTimeUnit } from '../types';
import { DurationService } from './durationComponent';

export const isOverlappingNextTimeUnit = flow(DurationService.parse, DurationService.isPositive);

export const timeUnitToDurationParameter = createHandler({
    [TimeUnit.Hour]: 'hour' as DateTimeUnit,
    [TimeUnit.Day]: 'day' as DateTimeUnit,
    [TimeUnit.Month]: 'month' as DateTimeUnit,
});

export const timeUnitToDurationObjectKey = createHandler({
    [TimeUnit.Hour]: 'hours' as keyof DurationObjectUnits,
    [TimeUnit.Day]: 'days' as keyof DurationObjectUnits,
    [TimeUnit.Month]: 'months' as keyof DurationObjectUnits,
});

export const durationFromTimeUnitCount = (timeUnit: TimeUnit) => (count: number) => {
    const durationUnit = timeUnitToDurationParameter(timeUnit);
    return DurationService.fromObject({
        [durationUnit]: count,
    });
};
